import { Component, useState} from "react";
import { useForm } from "../../../hooks/useForm";
import BaseModal from "../Base-modal";
import Input from "../../../blocks/Input";
import './role-modal.css'
import { useEffect } from "react";
import { useSnackbar } from 'notistack'
import { ajax } from "../../../scripts/helper";
import utils from "../../../scripts/utils";
import context from "../../../scripts/context";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs, { Dayjs } from 'dayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';







const Content = ({closeModal, showModal, onFilter, onChangeInput}) => {
    const {enqueueSnackbar} = useSnackbar()
    const [statusValue, setStatusValue] = useState()
    const [inputStatusValue, setInputStatusValue] = useState('');
    const [statusOptions, setStatusOptions] = useState([
        {label:'ACTIVE', data: {label: 'ACTIVE'}},
        {label: 'INACTIVE', data: {label: 'INACTIVE'}},
        {label: 'PENDING', data: {label: 'PENDING'}},
        {label: 'DELETED', data: {label: 'DELETED'}}
    ])
    const [inputFields, handleChange, setInputFields] = useForm(context.getRoleInputFilter(),onChangeInput)
    
    const onRoleInputFilter = (ins) => {
        setInputFields({
            ...ins
        })
    }
    context.addListenerRoleInputFilter((inputs)=>{onRoleInputFilter(inputs)})

    const [privilegesOption, setPrivilegesOption] = useState([])
    const [privilegeValue, setPrivilegeValue] = useState([])

    const getPrivileges = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.privilegeList,
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!res) return

        setPrivilegesOption(res.data)
    }


    useEffect( () => {
        
        if(showModal) getPrivileges()
            
    }, [showModal])

    


    return (
        <div className="inputs-container">
            <div>
                <label>name</label>
                <div className="field">
                    <Input inputField={inputFields.name}  onChange={handleChange}/>
                </div>
            </div>
            <div className="role-status">
                <label>status</label>
                <div style={{marginTop: '10px'}}>
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={statusOptions}
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    onChange={(event, newValue) => {
                        console.log(newValue)
                        setInputFields({
                            ...inputFields,
                            status: {
                                ...inputFields.status,
                                selected: newValue?.label,
                                value: newValue?.label
                            }
                        })
                        onChangeInput({
                            ...inputFields,
                            status: {
                                ...inputFields.status,
                                selected: newValue?.label,
                                value: newValue?.label
                            }
                        })
                    }}
                />
                </div>
            </div>
            <div className="privileges">
                <label>privileges</label>
                <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={privilegesOption}
                    getOptionLabel={(option) => option.name}
                    // defaultValue={[]}
                    value={inputFields.privileges.value}
                    filterSelectedOptions
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        />
                    )}
                    onChange={(event , newValue) => {
                        console.log(event , 'lllll', newValue)
                        setPrivilegeValue(newValue)
                        // let ids = []
                        // for(const v of newValue){
                        //     ids.push(v.id)
                        // }
                        // console.log(ids)
                        setInputFields({
                            ...inputFields,
                            privileges: {
                                ...inputFields.privileges,
                                selected: null,
                                value: newValue
                            }
                        })
                        onChangeInput({
                            ...inputFields,
                            privileges: {
                                ...inputFields.privileges,
                                selected: null,
                                value: newValue
                            }
                        })
                    }}
                    disableCloseOnSelect

                />
            </div>
            {/* <div>
                <label>mobile</label>
                <div className="field">
                    <Input inputField={inputFields.mobile}  onChange={handleChange} />
                </div>
            </div>
            <div> */}
                {/* <label>city</label>
                <div className="field">
                <Autocomplete 
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                    getOptionLabel={ (option) =>  option ? option.code : ''}
                    options={cityOptions}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={inputFields.city.value}
                    noOptionsText="No city"
                    onChange={(event, newValue) => {
                        setCityValue(newValue?.id);
                        console.log(newValue, ' newvalueeeeeee')
                        setInputFields({
                            ...inputFields,
                            city: {
                                ...inputFields.city,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        onChangeInput({
                            ...inputFields,
                            city: {
                                ...inputFields.city,
                                selected: newValue?.id,
                                value: newValue
                            }
                        })
                        console.log(newValue)
                    }}
                    onInputChange={(event, newInputValue) => {
                        if(newInputValue.trim())
                            setInputCityValue(newInputValue)
                    }}
                    renderOption={(props, option) => <li {...props}>{option.code}</li>}
                />
                </div> */}
            {/* </div> */}
        </div>
    )


}

const Footer = ({onFilter, closeModal, inputs}) => {
    // const [input, setInput] = useState(inputs)
    return (
        <div className="btns-container">
            <button className="clear" onClick={ () => {context.clearRoleInputfilter(); onFilter(context.getRoleInputFilter());closeModal()}}>Clear Filters</button>
            <button className="cancel" onClick={closeModal} >Cancel</button>
            <button className="apply" onClick={() => {onFilter(inputs);closeModal()}} >Apply Filters</button>
        </div>
    )
}
class RoleModal extends Component {
    state = {
        open: false,
        inputs: {}
    }

    openModal = () => this.setState({open: true})
    closeModal = () => this.setState({open: false})
    clearDate = () => { return ''}

    onChangeInputs = (inputs) => this.setState({inputs: inputs})

    render() {
        return (
            <BaseModal open={this.state.open} closeModal={this.closeModal} footer={Footer({onFilter: this.props.onFilter,closeModal: this.closeModal, inputs: this.state.inputs})}>
                <Content
                    {...this.props}
                    showModal={this.state.open}
                    closeModal={this.closeModal}
                    onChangeInput={this.onChangeInputs}
                />
            </BaseModal>
        )
    }
}

export default RoleModal